import { AddressSelectPage } from '@/pages/buyer/AddressSelectPage';
import { DesktopAddressSelectPage } from '@/pages/desktop/DesktopAddressSelectPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveAddressSelectPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <AddressSelectPage />
          <BottomNavigation activeId="address" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopAddressSelectPage />
      </div>
    </>
  );
}